import { StickyPlacement } from '../enums';

export const STICKY_STORY_WIDGET_ELEMENT_NAME = 'pimster-sticky-story-widget';
export const PATH_CONFIG_KEY = 'options';
export const STICKY_STORY_WIDGET_DEFAULT_PLACEMENT =
  StickyPlacement.BottomRight;
export const CLOSE_ANIMATION_DURATION_IN_MS = 250;
export const CLOSE_ANIMATION_DURATION_IN_S =
  CLOSE_ANIMATION_DURATION_IN_MS / 1000;
